export default {"src":"/_next/static/media/arrow-diagonal-white.99432abf.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};